import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.number.constructor.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getMallCheckEntityData } from '@/api/order';
import { getGoodsRegion } from '@/api/goodsCenter';
export default {
  name: 'GoodsVisibilityCheck',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    order_id: {
      type: [String, Number],
      default: ''
    },
    category_id: {
      type: [String, Number],
      default: ''
    }
  },
  data: function data() {
    return {
      searchForm: {
        goods_id: '',
        city_id: ''
      },
      regionList: [],
      dataList: [],
      errorDataList: [],
      loading: false,
      pagination: {
        page: 1,
        pagesize: 20,
        total_count: 0
      },
      sortParam: null,
      sort: null
    };
  },
  computed: {
    drawerTitle: function drawerTitle() {
      return "\u5546\u54C1\u53EF\u89C1\u6027\u6821\u9A8C\uFF08\u8BA2\u5355ID\uFF1A".concat(this.order_id, "\u3001\u83DC\u5355ID\uFF1A").concat(this.category_id, "\uFF09");
    },
    drawerVisible: {
      get: function get() {
        return this.visible;
      },
      set: function set(val) {
        this.$emit('update:visible', val);
      }
    }
  },
  watch: {
    visible: function visible(val) {
      if (val) {
        // 每次打开时重置搜索条件并重新加载数据
        this.searchForm = {
          goods_id: '',
          city_id: ''
        };
        this.pagination = {
          page: 1,
          pagesize: 20,
          total_count: 0
        };
        this.sortParam = null;
        this.sort = null;
        this.dataList = [];
        this.errorDataList = [];
      }
    }
  },
  created: function created() {
    this.getRegionList();
  },
  methods: {
    handleClose: function handleClose() {
      this.drawerVisible = false;
    },
    getRegionList: function getRegionList() {
      var _this = this;
      getGoodsRegion().then(function (res) {
        _this.regionList = res.data.list || [];
      });
    },
    fetchData: function fetchData() {
      var _this2 = this;
      this.loading = true;
      var params = {
        order_id: this.order_id,
        category_id: this.category_id,
        goods_id: this.searchForm.goods_id,
        city_id: this.searchForm.city_id,
        page: this.pagination.page,
        pagesize: this.pagination.pagesize
      };
      if (this.sortParam) {
        params.sort = this.sort;
        params.sortParam = this.sortParam;
      }
      getMallCheckEntityData(params).then(function (res) {
        _this2.dataList = res.data.data_list || [];
        _this2.errorDataList = res.data.error_list || [];
        _this2.pagination.total_count = res.data.total_count || 0;
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    handleSearch: function handleSearch() {
      this.pagination.page = 1;
      this.fetchData();
    },
    handleReset: function handleReset() {
      this.searchForm = {
        goods_id: '',
        city_id: ''
      };
      this.pagination.page = 1;
      this.sortParam = null;
      this.sort = null;
      this.fetchData();
    },
    handlePageChange: function handlePageChange(page) {
      this.pagination.page = page;
      this.fetchData();
    },
    sortChange: function sortChange(_ref) {
      var prop = _ref.prop,
        order = _ref.order;
      if (order) {
        this.sortParam = prop;
        this.sort = order === 'ascending' ? 'asc' : 'desc';
      } else {
        this.sortParam = null;
        this.sort = null;
      }
      this.pagination.page = 1;
      this.fetchData();
    }
  }
};